// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2zbJD","image":"styles_image__2scrd","text":"styles_text__VQl-p"};